import { createContext } from 'react'

import type {
  AnalyticsQueryAggregate,
  AnalyticsQueryFilter,
  AnalyticsQueryOrder,
  LookupFields,
} from '@hap/analytics'
import { VOID_FUNC } from '@hap/constants'
import { Timespan } from '@hap/utils'
import { createNanoId } from '@hap/utils'

import { DEFAULT_INITIAL_VALUE } from './constants'
import { LoadQueryAction, PivotField, QueryTask, SavedQueryState } from './types'

export const SavedQueryContext = createContext<{
  id: string
  state: SavedQueryState
  pagination: {
    page: number
    size: number
  }
  actions: {
    setTimespan: (timespan: Timespan.Info) => void
    setFilters: (filters: AnalyticsQueryFilter[]) => void
    setOrder: (order: AnalyticsQueryOrder[]) => void
    setColumns: (columns: PivotField[]) => void
    setRows: (rows: PivotField[]) => void
    setAggregations: (aggregations: AnalyticsQueryAggregate[]) => void
    setTask: (task: QueryTask) => void
    setFields: (fields: LookupFields[]) => void
    setPage: (page: number) => void
    load: (data: LoadQueryAction['payload']) => void
  }
}>({
  id: createNanoId(),
  state: {
    meta: { isDirty: false, isOwner: true, isSaved: false },
    relationships: {
      task: null,
    },
    data: {
      params: DEFAULT_INITIAL_VALUE,
    },
  },
  pagination: {
    page: 1,
    size: 100,
  },
  actions: {
    setTimespan: VOID_FUNC,
    setFilters: VOID_FUNC,
    setOrder: VOID_FUNC,
    setColumns: VOID_FUNC,
    setRows: VOID_FUNC,
    setAggregations: VOID_FUNC,
    setTask: VOID_FUNC,
    setFields: VOID_FUNC,
    setPage: VOID_FUNC,
    load: VOID_FUNC,
  },
})
